import api from './api';

export interface UserProfile {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  profilePictureUrl: string;
  address?: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
}

export interface UpdateUserProfileRequest {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  profilePictureUrl: string;
}

export interface UserSetting {
  key: string;
  value: string;
  type: string;
}

export interface UpdateUserSettingRequest {
  key: string;
  value: string;
  type: string;
}

export const userService = {
  getUserProfile: async (): Promise<UserProfile> => {
    try {
      const response = await api.get('/users/profile');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUserProfile: async (userData: UpdateUserProfileRequest): Promise<UserProfile> => {
    try {
      const response = await api.put('/users/profile', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUserSettings: async (): Promise<UserSetting[]> => {
    try {
      const response = await api.get('/user-settings');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUserSettings: async (settings: UpdateUserSettingRequest[]): Promise<void> => {
    try {
      await api.put('/user-settings', settings);
    } catch (error) {
      throw error;
    }
  },
};
